import {
  VERIFIED_STATUSES,
  SUBMITTED_STATUSES,
  NEED_VERIFICATION_STATUSES,
  REJECTED_STATUSES,
  AFTER_TRIAL_STATUSES,
  BLACKLISTED_STATUSES,
  TRIAL_STATUSES,
} from 'shared_js/constants/singleKycStatus';

import getDayDifference from 'shared_js/helpers/dateHelper/getDayDifference';

export default {
  isUserVerified(state) {
    return VERIFIED_STATUSES.includes(state.sendMoneyUserInfo.status);
  },
  isUserSubmitted(state) {
    return SUBMITTED_STATUSES.includes(state.sendMoneyUserInfo.status);
  },
  isUserNeedVerification(state) {
    return NEED_VERIFICATION_STATUSES.includes(state.sendMoneyUserInfo.status);
  },
  isUserVerificationRejected(state) {
    return REJECTED_STATUSES.includes(state.sendMoneyUserInfo.status);
  },
  isUserBlacklisted(state) {
    return BLACKLISTED_STATUSES.includes(state.sendMoneyUserInfo.status);
  },
  isUserTrial(state) {
    return TRIAL_STATUSES.includes(state.sendMoneyUserInfo.status);
  },
  isUserAfterTrial(state) {
    return AFTER_TRIAL_STATUSES.includes(state.sendMoneyUserInfo.status);
  },
  isUserKyc(state) {
    return state.sendMoneyUserInfo.trial_type === 'kyc';
  },
  isUserHasPIN(state) {
    return state.hasPIN === true;
  },
  isPowerUser(state) {
    return state.sendMoneyUserInfo.user_type === 'power';
  },
  userStatus(state) {
    return state.sendMoneyUserInfo.status;
  },
  verificationRejectedReasons(state) {
    const { reason } = state.sendMoneyUserInfo;

    let reasons = reason ? reason.split(',') : [];
    reasons = reasons.map(item => item.trim());

    return reasons;
  },
  activeFeatures(state) {
    return state.sendMoneyUserInfo.active_features;
  },
  kycSource(state) {
    return state.sendMoneyUserInfo.kyc_source;
  },
  firstApprovedAt(state) {
    const { sendMoneyUserInfo } = state;
    const listApprovedAt = [
      sendMoneyUserInfo.approved_at,
      sendMoneyUserInfo.kyc_pre_verified_at,
      sendMoneyUserInfo.kyc_verified_at,
      sendMoneyUserInfo.kyc_oy_verified_at,
      sendMoneyUserInfo.kyc_lkd_verified_at,
    ].filter(Boolean);

    if (listApprovedAt.length > 0) {
      return Math.min(...listApprovedAt.map(val => new Date(val)));
    }

    return null;
  },

  isShowKuQrisOnBoarding(state, getters, rootState) {
    return (
      rootState.digitalSend.toggleAutoRegisterQris &&
      (!state.qrisUserInfo.created_at ||
        state.qrisUserInfo.status === 'unregistered')
    );
  },
  isShowVerificationKUQrisKycSubmitted(state, getters, rootState) {
    return (
      rootState.digitalSend.toggleAutoRegisterQris &&
      (getters.isShowKuQrisOnBoarding ||
        (['submitted', 'pending'].includes(state.qrisUserInfo.status) &&
          new Date(state.qrisUserInfo.created_at) >=
            new Date(state.sendMoneyUserInfo.created_at)))
    );
  },
  isShowBlueBoxQris(state, getters) {
    return (
      getters.firstApprovedAt !== null &&
      state.qrisUserInfo.status === 'approved' &&
      new Date(getters.firstApprovedAt) <=
        new Date(state.qrisUserInfo.created_at) &&
      (state.qrisBlueBoxFirstDate === '' ||
        getDayDifference(new Date(state.qrisBlueBoxFirstDate), new Date()) <= 3)
    );
  },
  isOOMFlow(state) {
    return state.oomFlowEligibility;
  },
};
